<template>
   <ValidationProvider ref="providerRef" v-slot="{ errors }" :name="name || label" :rules="rules" :vid="vid" class="form__item" tag="div">
      <div
         :class="[
            { [className]: true },
            { 'form-customize--error': errors[0] && className === 'form-customize' },
            { 'form-custom--error': errors[0] && className === 'form-custom' }
         ]"
      >
         <label v-if="label && isLabel" class="label-title" v-bind:style="[styleLable]">
            <span>{{ label }}</span>
            <span v-if="hasStar" class="required position-relative">*</span>
            <span>:</span>
         </label>
         <div class="form-input">
            <input
               v-if="type === 'fmNumber'"
               :id="name || label"
               v-model="innerValue"
               :placeholder="placeholder"
               autocomplete="new-password"
               class="form-control"
               type="text"
               @input="onInput"
            />
            <input
               v-if="type === 'number'"
               :id="name || label"
               v-model="innerValue"
               :disabled="disabled"
               :placeholder="placeholder"
               :readonly="readonly"
               autocomplete="new-password"
               class="form-control"
               min="1"
               onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
               pattern="[0-9]*"
               step="1"
               type="number"
               @input="onInput"
               @paste.prevent="onPaste"
            />
            <input
               v-if="type === 'phone'"
               :id="name || label"
               v-model="innerValue"
               :disabled="disabled"
               :placeholder="placeholder"
               :readonly="readonly"
               autocomplete="new-password"
               class="form-control"
               onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
               pattern="[0-9]*"
               type="number"
               @input="onInput"
               @paste.prevent="onPaste"
            />
            <input
               v-if="type === 'numPassword'"
               :id="name || label"
               v-model="innerValue"
               :placeholder="placeholder"
               autocomplete="new-password"
               class="form-control"
               pattern="[0-9]*"
               type="password"
               @input="onInput"
               :disabled="disabled"
            />
            <input
               v-if="type === 'text' || type === 'password'"
               :id="name || label"
               v-model="innerValue"
               :inputmode="inputmode"
               :maxlength="maxlength"
               :placeholder="placeholder"
               :type="type"
               autocomplete="new-password"
               class="form-control"
               @input="onInput"
               :disabled="disabled"
            />

            <template v-if="type === 'textarea'">
               <textarea
                  :id="name || label"
                  v-model="innerValue"
                  :maxlength="maxlength"
                  :placeholder="placeholder"
                  :rows="rows || rowTextArea"
                  :type="type"
                  autocomplete="new-password"
                  class="form-control"
                  cols="50"
                  @input="onInput"
                  :disabled="disabled"
               ></textarea>
            </template>

            <input
               v-if="type === 'date'"
               :id="name || label"
               v-model="innerValue"
               :placeholder="placeholder"
               autocomplete="off"
               class="form-control js-datepicker"
               type="text"
               @input="onInput"
            />
            <div v-if="$slots.prefix" class="prefix">
               <slot name="prefix"></slot>
            </div>
            <span v-if="rightIcon" class="input-addon" @click="onClickRightIcon"><i :class="rightIcon"></i></span>
            <span v-if="hasResetIcon && value != ''" class="input-close" @click="reset">
               <i class="icon-fonts icon-fonts--close"></i>
            </span>
         </div>
         <slot name="error">
            <p v-if="!errors[0] && hint" class="notice-text">{{ hint }}</p>
            <p v-if="errors[0]" class="error-text">{{ errors[0] }}</p>
         </slot>
      </div>
   </ValidationProvider>
</template>
<script>
import $ from 'jquery'
import { getDevice } from '@/ultils/device'

export default {
   name: 'Input',
   props: {
      vid: {
         type: String,
         default: undefined
      },
      name: {
         type: String,
         default: ''
      },
      label: {
         type: String,
         default: ''
      },
      rules: {
         type: [Object, String],
         default: ''
      },
      placeholder: {
         type: String,
         default: ''
      },
      hint: {
         type: String,
         default: ''
      },
      type: {
         type: String, // text, number, password, phone, fmNumber, numPassword ...
         default: 'text'
      },
      className: {
         type: String,
         default: 'form-customize'
      },
      hasResetIcon: {
         type: Boolean,
         default: false
      },
      readonly: {
         type: Boolean,
         default: false
      },
      disabled: {
         type: Boolean,
         default: false
      },
      rightIcon: {
         type: String,
         default: 'icon-fonts icon-fonts--undefined'
      },
      onClickRightIcon: {
         type: Function,
         default: () => {}
      },
      value: {
         type: null,
         default: ''
      },
      hasStar: {
         type: Boolean,
         default: false
      },
      isLabel: {
         type: Boolean,
         default: true
      },
      maxlength: {
         type: Number, // text, number, password, phone, fmNumber, numPassword ...
         default: 500
      },
      inputmode: {
         type: String,
         default: 'text'
      },
      rows: {
         type: String,
         default: ''
      },
      styleLable: {
         type: Object,
         default: () => ({}),
      },
      rowTextArea: {
         type: Number,
         default: 4
      }
   },
   data: () => ({
      innerValue: '',
      oldInnerValue: ''
   }),
   methods: {
      numberWithCommas(n) {
         return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      blur() {
         if (getDevice() === 'Android') {
            $(`#${this.name || this.label}`).blur()
         }
      },
      focus() {
         if (getDevice() === 'Android') {
            $(`#${this.name || this.label}`).focus()
         }
      },
      checkAndUpdateVal(newVal) {
         this.blur()
         if (this.type === 'fmNumber') {
            let result = newVal.replace(/,/g, '')
            if (/\D/.test(result)) {
               this.$emit('input', this.oldInnerValue)
               this.innerValue = this.oldInnerValue
            } else {
               if (/^0/.test(result) && result.length > 1) {
                  this.$emit('input', result.replace(/^0+/, ''))
                  this.innerValue = this.numberWithCommas(result.replace(/^0+/, ''))
               } else {
                  this.$emit('input', result)
                  this.innerValue = this.numberWithCommas(result)
               }
            }
         } else if (this.type === 'numPassword') {
            if (/\D/.test(newVal)) {
               this.$emit('input', this.oldInnerValue)
               this.innerValue = this.oldInnerValue
            } else {
               this.$emit('input', newVal)
               this.innerValue = newVal
            }
         } else {
            this.$emit('input', newVal)
            this.innerValue = newVal
         }
         this.oldInnerValue = this.innerValue
         this.focus()
      },
      onInput(evt) {
         this.checkAndUpdateVal(evt.target.value)
      },
      onPaste(evt) {
         this.checkAndUpdateVal(evt.clipboardData.getData('text'))
      },
      reset() {
         this.$emit('input', '')
         this.innerValue = ''
      },
      resetValidate() {
         this.$refs.providerRef.reset()
      }
   },
   watch: {
      value(val) {
         if (this.type === 'fmNumber') {
            this.innerValue = this.numberWithCommas(val)
         } else {
            this.innerValue = val
         }
         this.oldInnerValue = this.innerValue
      }
   },
   created() {
      if (this.type === 'fmNumber') {
         this.innerValue = this.numberWithCommas(this.value)
      } else {
         this.innerValue = this.value
      }
      this.oldInnerValue = this.innerValue
   }
}
</script>

<style lang="scss" scoped>
.form-input {
   &:has(.prefix) {
      .form-control {
         padding-right: 70px;
      }
   }
}
</style>
